import React, { CSSProperties, useState } from 'react';
import { Button, Modal } from 'antd';
import "../modal/customRecordDetailModal.scss";
import RecordDetailsUsingBlueprintApi from '../../components/recordDetailsUsingBlueprintApi/recordDetailsUsingBlueprintApi';
import { AccessLevel, RowLevelAction } from '../../types/types';
import { getEnumKeyByEnumValue } from '../../utils/utils';
import { ButtonType } from 'antd/es/button';


type CustomRecordDetailModalProps = {
  title: string;
  actionName: string;
  platformAction?: string;
  blueprintApi: string;
  isCreateFlow: boolean;
  userAccessLevel: AccessLevel;
  moduleCode: string;
  allowEdits: boolean;
  viewPageBluPrint?: any;
  urlparams?: Map<string, string>;
  onSuccess?: (value: any) => void;
  actionButtonStyle?: CSSProperties | undefined;
  actionButtonIcon?: React.ReactNode;
  actionButtonType?: ButtonType;
};

const CustomRecordDetailModal: React.FC<CustomRecordDetailModalProps> = ({
  title,
  platformAction,
  blueprintApi,
  isCreateFlow,
  userAccessLevel,
  moduleCode,
  allowEdits,
  actionName,
  viewPageBluPrint,
  urlparams,
  onSuccess,
  actionButtonIcon,
  actionButtonStyle,
  actionButtonType
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAction = (val: boolean) => {
    setIsModalOpen(val);
  };

  const getKeyFromRowlevelActionVal = (val: string): RowLevelAction => {
    return getEnumKeyByEnumValue(RowLevelAction, val) as RowLevelAction;
  }

  return (
    <>
      <Button type={actionButtonType ?? "primary"} onClick={() => handleAction(true)} icon={actionButtonIcon} style={actionButtonStyle}>
        {actionName}
      </Button>

        <Modal footer={null} title={title} open={isModalOpen} onCancel={() => handleAction(false)} className={"custom-modal-width"} bodyStyle={{ width: "100%" }} okButtonProps={{ hidden: true }}
          cancelButtonProps={{ hidden: true }} >



            <RecordDetailsUsingBlueprintApi
              viewPageBluPrint={viewPageBluPrint}
              urlparams={urlparams ?? new Map()}
              platformAction={getKeyFromRowlevelActionVal(platformAction ?? "View")}
              setOpen={handleAction}
              blueprintApi={blueprintApi}
              title={title}
              isCreateFlow={isCreateFlow}
              userAccessLevel={userAccessLevel}
              moduleCode={moduleCode}
              allowEdits={allowEdits}
              onSuccess={onSuccess}
            />


        </Modal>

    </>
  );
};

export default CustomRecordDetailModal;
